import { http, ep } from '../../client/http';

export const sliderRepo = {
  get: async () => {
    const res = await http.get(ep('slider/list'), {
      params: { status: true }
    });
    return res.data.data;
  }
};
